import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Icon = styled.div`
  ${({ theme }) => css`
    svg {
      width: 150px;
      height: 150px;
      margin-right: ${theme.spacing(1)};
      flex-shrink: 0;
    }
  `}
`;
